import React from 'react';
import _ from 'lodash';

import { ApiRequestTable } from 'modules/layer00';
import { useRefundDetailModalQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IRefund {
  createdAt: DateTime;
  wasSuccessful: boolean;
  apiRequests: ApiRequestTable.IApiRequest[];
}

export interface IData {
  refund: IRefund | null;
}

export function useQuery(refundId: string) {
  const tuple = useRefundDetailModalQuery({
    variables: { refundId }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        refund: tuple.data?.refund ? {
          wasSuccessful: false,
          createdAt: DateTime.fromISO(tuple.data.refund.metaCreated),
          apiRequests: _.map(tuple.data.refund.apiRequests.nodes, (req): ApiRequestTable.IApiRequest => ({
            id: req.id,
            isOK: req.httpStatusCode === 200,
            metaCreated: DateTime.fromISO(req.metaCreated),
            method: req.method,
            requestBody: req.requestBody,
            responseBody: req.responseBody,
            statusCode: req.httpStatusCode,
            url: req.url
          }))
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
